module.exports = __webpack_public_path__ + "img/Weapon_56.1f6ffb47.png";